import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/** Thin azure progress bar pinned under the navbar. */
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-[60] h-[2px] origin-left bg-azure-500"
      aria-hidden="true"
    />
  );
};

export default ScrollProgress;
